import { render, staticRenderFns } from "./section-carrusel.vue?vue&type=template&id=e4372440&scoped=true"
import script from "./section-carrusel.vue?vue&type=script&lang=js"
export * from "./section-carrusel.vue?vue&type=script&lang=js"
import style0 from "./section-carrusel.vue?vue&type=style&index=0&id=e4372440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4372440",
  null
  
)

export default component.exports